<template>
  <div class="header-bg">
    <div class="header">
      <div class="logo">
        <img @click="$router.push({path: 'Home'})" :src="logo" alt />
      </div>
      <div class="btn-group">
        <div class="lang-icon" @click="changLang" v-text="lang ==='cn'? 'EN' : 'HK'"></div>
        <div v-if="!page_error" @click="goRegister" class="register-btn" v-text="path"></div>
        <div v-else class="search-box">
          <input placeholder="Search" type="text" />
          <span class="search-icon"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: window.localStorage.getItem('locale'),
      page_error: false
    };
  },
  props: ["logo", "path"],
  created() {
    this.page_error = ![
      "/Home",
      "/Register",
      "/Contact",
      "/PrivacyTerms"
    ].includes(this.$route.path)
  },
  methods: {
    changLang () {
      let lang = window.localStorage.getItem('locale') == 'cn' ? 'en' : 'cn'
      window.localStorage.setItem('locale', lang)
      location.reload()
    },
    goRegister() {
      switch (this.path) {
        case "REGISTER":
          this.$router.push({ path: "Register" });
          break;
        case "BACK TO HOMEPAGE":
          this.$router.push({ path: "Home" });
          break;
        case "ACTION ORIENTED CTA":
          this.$router.push({ path: "Contact" });
          break;
        case "LOGIN":
          window.location.href = "https://audit.thewidi.com/";
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header-bg {
  height: 80px;
  width: 100%;
  border-bottom: 1px solid #ecf0f1;
  .header {
    max-width: 940px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    .logo {
      height: 30px;
      width: 140px;
      img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
    .btn-group{
      display: flex;
    }
    .register-btn {
      border: 1px solid rgba(35, 31, 32, 1);
      border-radius: 3px;
      padding: 0 20px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      font-size: 15px;
      cursor: pointer;
      font-family: "Medium";
    }
    .lang-icon {
        // margin-left: 8px;
        white-space: nowrap;
        border-radius: 3px;
        padding: 0 20px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        font-size: 15px;
        cursor: pointer;
        font-family: "Medium";
      }
    .search-box {
      height: 40px;
      position: relative;
      & > input {
        width: 230px;
        padding: 10px;
        box-sizing: border-box;
        outline: none;
        border: 1px solid #bdc3c7;
        color: #231f20;
        border-radius: 3px;
        height: 100%;
      }
      .search-icon {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 1px solid #606060;
        position: absolute;
        right: 10px;
        top: 42%;
        transform: translateY(-50%);
      }
      .search-icon::after {
        content: "";
        width: 8px;
        height: 1px;
        background: #606060;
        display: block;
        position: absolute;
        right: 9px;
        transform: rotate(-45deg);
        top: 13px;
      }
    }
    @media screen and (max-width: 768px) {
      .logo {
        width: 50px;
        height: 45px;
      }
      .register-btn {
        width: auto;
      }
    }
  }
}
</style>
